export const environment = {
  production: true,
  apiUrl: 'https://api.herrsiim.ee/api',
  socketUrl: 'https://api.herrsiim.ee/socket',
};
